import { API } from "../../api";
async function send_generic_email(request) {
    // console.log("send_generic_email -> request", request);
    return await new API().apiPost({
        baseUrl: process.env.LETS_TRADE_NOTIFICATION_URL ?? "",
        endpoint: `v1/send/generic/email`,
        content: request,
        authorization: process.env.LETS_TRADE_CLIENT_TOKEN,
    });
}
export { send_generic_email };
